export function setAllHyperlinksToTargetBlankInHTML(content) {
    const htmlNode = document.createElement("div")
    htmlNode.innerHTML = content
    htmlNode.querySelectorAll("a").forEach(function (node) {
        node.target = "_blank"
    })
    return htmlNode.innerHTML
}
